import { create } from 'zustand'

interface ModalM3State {
  modalM3: {
    isOpen: boolean
    onSuccess?: () => void
  }
  setModalM3: (modalM3: { isOpen: boolean; onSuccess?: () => void }) => void
  reset: () => void
}

const initialState = {
  modalM3: {
    isOpen: false
  }
}

export const useModalM3Store = create<ModalM3State>()((set) => ({
  ...initialState,
  setModalM3: (modalM3) => set({ modalM3 }),
  reset: () =>
    set({
      modalM3: initialState.modalM3
    })
}))
